import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Ticket} from '../_models/tickets.model';

@Injectable({
    providedIn: 'root'
})
export class TicketsService {

    constructor(private http: HttpClient) {
    }

    getTicketById(ticketId: string) {
        return this.http.get<Ticket>('/api/getTicketById?ticketId=' + ticketId);
    }

    createTicket(ticketObject) {
        return this.http.post('/api/createTicket', ticketObject);
    }

    cancelTicket(ticketId) {
        return this.http.put('/api/cancelTicket?ticketId=' + ticketId, {});
    }

    changeTicketStatus(ticketId, status) {
        return this.http.put('/api/changeTicketStatus?ticketId=' + ticketId + '&status=' + status, '');
    }

    changeTicketPriority(ticketId, priority) {
        return this.http.put('/api/changeTicketPriority?ticketId=' + ticketId + '&priority=' + priority, '');
    }

    getUserTickets() {
        return this.http.get('/api/getCurrentUserTicketsWithName');
    }

    getAllTicketsByMainId() {
        return this.http.get('/api/getAllTicketsByMainIdWithName');
    }


    getAllTickets() {
        return this.http.get('/api/getAllTicketsWithName');
    }


    getCurrentUser() {
        return this.http.get('/api/getCurrentUser');
    }

    getUserById(userId: string) {
        return this.http.get('/api/getUserById?userId=' + userId);
    }


    // Notes Request
    getAllTicketNotes(ticketId) {
        return this.http.get('/api/getAllTicketNotes?ticketId=' + ticketId);
    }

    addTicketNote(moduleName, id, note: object) {
        return this.http.post('/api/createNote?objectId=' + id + '&objectType=' + moduleName, note);
    }

    sendTicketEmail(type: string, ticketId: string, noteId?: any) {
        return this.http.get('/api/sendTicketEmail?type=' + type + '&ticketId=' + ticketId + '&noteId=' + noteId);
    }

}

